export const normalizeCupsForSearch = (value) =>
    String(value || "")
        .trim()
        .toUpperCase()
        .replace(/\s+/g, "");

export const shouldLockFieldByValueAndDirty = (value, isDirty) => {
    const hasValue = (() => {
        if (value === null || value === undefined || value === false) return false;
        if (typeof value === "string") return value.trim() !== "";
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === "object") return Object.keys(value).length > 0;
        return true;
    })();

    return hasValue && !isDirty;
};

export const hasMissingRequiredAddressFields = (address) => {
    const required = [
        address?.cups_tv,
        address?.cups_nv,
        address?.cups_dp,
        address?.cups_id_provincia,
        address?.cups_id_municipi,
        address?.cups_id_poblacio,
    ];

    return required.some((value) => value === null || value === undefined || String(value).trim() === "");
};
